/**
 * Детали клиента для карточки (drawer). Живой источник —
 * GET /admin/clients/{clinic_id}; мок достраивает строку списка.
 */

import {apiEnabled, http} from '@services/utils';

import {buildClientDetail} from '../detailMocks';
import {MOCK_CLIENTS} from '../mocks';
import type {ClientDetail} from '../types';

import {toClientDetail} from './toClientDetail';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getClientDetail = async (id: string): Promise<ClientDetail> => {
  if (!apiEnabled) {
    await sleep(220);
    const client = MOCK_CLIENTS.find((c) => c.id === id);
    if (!client) throw new Error('client_not_found');
    return buildClientDetail(client);
  }

  const raw = await http<unknown>(`admin/clients/${encodeURIComponent(id)}`, {
    skipCaseConversion: true,
  });
  return toClientDetail(raw);
};
